import { FormControl, MenuItem, Select } from '@material-ui/core';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Scrollbars from 'react-custom-scrollbars';
import Alert from 'react-s-alert';
import SVG from 'react-inlinesvg';
import Media from 'react-media';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { AmealioLoader } from '../../../../../../Loader/AmealioLoader';
import { NewInputText } from '../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent';
import { MobileTopHeader } from '../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader';
import { BackLogoIconButton } from '../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText';
import { ReusableOnboardingButton } from '../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';
import { TopTextReusableComponent } from '../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent';
import { create_custom_menu } from '../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction';

const CreateCustomMenu = (props) => {
  let history = useHistory();

  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});

  const handleNextStep = (e) => {
    setStep(e);
  };

  const [count, setCount] = useState(1);

  const onClickNext = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  const Capitalize = (str, name) => {
    return formik.setFieldValue(
      name,
      str.charAt(0).toUpperCase() + str.slice(1)
    );
  };

  const titleCase = (str, name) => {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return formik.setFieldValue(name, str.join(' '));
  };

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let catNameElement = document.getElementById('name');
      catNameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let description = document.getElementById('description');
      description.focus();
    }
  }, [count]);

  const Onsuccess = () => {
    if (props?.dash) {
      history.push('/menusetup-dashboard');
    } else {
      history.push('/casual-fine-dining/menusetup');
    }
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      description: '',
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(128, 'Must be 128 characters or less')
        .required('Menu name is required'),
      description: yup.string().required('description is required'),
    }),
    onSubmit: (values) => {
      console.log('submitted');
      let formData = {};
      formData = { ...formik.values };
      formData.restaurant = props?.serviceType?.vendor_id;
      formData.menuType = 'CUSTOM';
      const token = props.auth.user.accessToken;
      props.create_custom_menu(formData, token, Onsuccess);
    },
  });

  // console.log(props.serviceType.vendor_id);
  return (
    <>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className={`mobile-pb-70 p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6  new-subscription-onboarding-component ${
                  !props.dash && `onboarding_process_screen_left`
                }`}
              >
                {!props.dash && (
                  <>
                    <Media query="(min-width: 992px)">
                      <div className="col-12">
                        <BackLogoIconButton
                          displayBackText={true}
                          displayArrow={true}
                          //backButtonClicked={"/casual-fine-dining/menusetup"}
                          backButtonClicked={() =>
                            history.push('/casual-fine-dining/menusetup')
                          }
                          notDisplaProgressBar={true}
                          workWithLinkORClick={true}
                        />
                      </div>
                    </Media>
                    <Media query="(max-width: 991px)">
                      <MobileTopHeader
                        link={true}
                        onLink={'/casual-fine-dining/menusetup'}
                      />
                    </Media>
                  </>
                )}
                <div
                  className={`${
                    !props.dash && `onboarding_process_screen-button-map`
                  }`}
                >
                  <Form className="mb-4">
                    {step === 1 && (
                      <React.Fragment>
                        <div className="mb-4">
                          <TopTextReusableComponent
                            headingText={'Create custom Menu'}
                            headingParagraph="Create Your own Menu"
                          />
                        </div>
                        <Form.Label className="f14-500 mb-3">
                          Custom Menu Name
                        </Form.Label>
                        <Row>
                          <Col md={8}>
                            <NewInputText
                              controlClass={'name'}
                              labelText="Ex:Birthday Menu"
                              extraClass={`mb-1 w-100 ${
                                formik.errors.name && formik.touched.name
                                  ? 'enError'
                                  : ''
                              }`}
                              name="name"
                              //onChange={formik.handleChange}
                              onChange={(e) =>
                                titleCase(e.target.value, 'name')
                              }
                              value={formik.values.name}
                              onFocusOut={formik.handleBlur}
                              helpTextDisplay={true}
                              helperTextBottom={
                                '(Your Menu Name will help people find the items with ease and your Special Offerings). Set Menu for Special Occasions Ex. Wedding, Birthday Menu etc.'
                              }
                            />
                            {formik.errors.name && formik.touched.name ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.name}
                              </div>
                            ) : null}
                          </Col>
                        </Row>

                        <Row className="mt-4">
                          <Col md={8}>
                            <NewInputText
                              labelText="Menu Description Upto 500 characters *"
                              extraClass="mb-1 w-100"
                              multiline={true}
                              rows="4"
                              name="description"
                              //onChange={formik.handleChange}
                              onChange={(e) =>
                                Capitalize(e.target.value, 'description')
                              }
                              value={formik.values.description}
                            />
                            {formik.errors.description &&
                            formik.touched.description ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.description}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                        <hr />
                        <div
                          style={{ position: props.dash && 'relative' }}
                          className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5"
                        >
                          <div>
                            <ReusableOnboardingButton
                              buttonTitle="Back Button"
                              buttonClass="btn-lg btn btn-outline-secondary"
                              buttonText="Cancel"
                              buttonStyle={{ border: '1px solid' }}
                              onClick={() =>
                                history.push('/menusetup-dashboard')
                              }
                            />
                            <ReusableOnboardingButton
                              buttonTitle="Next Button"
                              buttonClass="btn-lg btn btn-danger ml-3 mobile-btn-large"
                              buttonText="Next"
                              buttonType="button"
                              onClick={(e) => onClickNext(e)}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </>
  );
};

CreateCustomMenu.propTypes = {
  auth: PropTypes.object.isRequired,
  create_custom_menu: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  serviceType:
    state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, { create_custom_menu })(
  CreateCustomMenu
);
